import { AxiosRequestController } from '@/modules/core/app/models/AxiosRequestController';
import { commits, getters } from '/@/modules/core/app/helpers/store';
import { BaseService } from '@/modules/core/app/services/abstracts/BaseService';
import { AxiosRequestMethod } from '@/modules/core/app/enums/AxiosRequestMethod';
import { Route } from '@/modules/core/app/constants/api.constants';

class ApiService extends BaseService {
  addRequest(requestController: AxiosRequestController): void {
    commits.api.addRequest(requestController);
  }

  removeRequest(url: string): void {
    commits.api.removeRequest(url);
  }

  cancelPendingGetRequests(): void {
    this.cancelPendingRequests(AxiosRequestMethod.GET);
  }

  cancelPendingPostRequests(): void {
    this.cancelPendingRequests(AxiosRequestMethod.POST);
  }

  cancelPendingGetRequestsExceptIn(exceptions: Array<Route | string>): void {
    this.cancelPendingRequests(AxiosRequestMethod.GET, exceptions);
  }

  cancelPendingRequestByURL(url: string): void {
    const requests: AxiosRequestController[] = getters.api.getActiveRequests();

    requests.forEach((request: AxiosRequestController) => {
      if (request.url !== url) {
        return;
      }

      request.controller.abort();
      this.removeRequest(request.url);
    });
  }

  private cancelPendingRequests(requestMethod: AxiosRequestMethod, exceptions?: string[]): void {
    const requests: AxiosRequestController[] = getters.api.getActiveRequests();

    requests.forEach((request: AxiosRequestController) => {
      if (request.method !== requestMethod) {
        return;
      }

      if (exceptions && exceptions.find((exception: string) => request.url.includes(exception))) {
        return;
      }

      request.controller.abort();
      this.removeRequest(request.url);
    });
  }

  shouldBlockRequest(url: string): boolean {
    if (!getters.api.getAllowedRequestUrl()) {
      return false;
    }

    return url !== getters.api.getAllowedRequestUrl();
  }
}

export default new ApiService();
